import React, {Suspense} from "react";
import {useTranslation, Trans} from "react-i18next";

function HeaderComponent()
{
	const {t} = useTranslation('translation');
    return <div className="home"  id="wrapper">
	<main className="full_width">
	  <h2>{t('impress.h2')}</h2>
	  <h3 id="m14">{t('impress.toc.#1')}</h3>
	  <Trans i18nKey="impress.intro" components={{p: <p />}}></Trans>
	  <h3>{t('impress.toc.h3')}</h3>
	  <ul className="index">
		  <li><a className="index-link" href="#m14">{t('impress.toc.#1')}</a></li>
		  <li><a className="index-link" href="#m3">{t('impress.toc.#2')}</a></li>
		  <li><a className="index-link" href="#mOverview">{t('impress.toc.#3')}</a></li>
		  <li><a className="index-link" href="#m13">{t('impress.toc.#4')}</a></li>
		  <li><a className="index-link" href="#m27">{t('impress.toc.#5')}</a></li>
		  <li><a className="index-link" href="#m134">{t('impress.toc.#6')}</a></li>
		  <li><a className="index-link" href="#m317">{t('impress.toc.#7')}</a></li>
		  <li><a className="index-link" href="#m225">{t('impress.toc.#8')}</a></li>
		  <li><a className="index-link" href="#m182">{t('impress.toc.#9')}</a></li>
		  <li><a className="index-link" href="#m136">{t('impress.toc.#10')}</a></li>
		  <li><a className="index-link" href="#m12">{t('impress.toc.#11')}</a></li>
		  <li><a className="index-link" href="#m15">{t('impress.toc.#12')}</a></li>
		  <li><a className="index-link" href="#m10">{t('impress.toc.#13')}</a></li>
		  <li><a className="index-link" href="#m42">{t('impress.toc.#14')}</a></li>
	  </ul>
	  <h3 id="m3">{t('impress.toc.#2')}</h3>
	  
	  <Trans i18nKey="impress.responsible" components={{ strong: <strong />, p: <p />, 
		MyLink1:(<a href="mailto:info@notensatz.com" target="_blank" rel="noopener noreferrer">link</a>), 
		MyLink2:(<a href="http://notensatz.com/de/impress_datenschutz.html" target="_blank" rel="noopener noreferrer">link</a>)}}/>

	  <h3 id="mOverview">{t('impress.toc.#3')}</h3>
	  <p>{t('impress.overview.p')}</p>
	  <h4>{t('impress.overview.h4_dat')}</h4>
	  <Trans i18nKey="impress.overview.li_dat" components={{ ul: <ul />, li: <li />}}></Trans>
	  <h4>{t('impress.overview.h4_cat')}</h4>
	  <Trans i18nKey="impress.overview.li_cat" components={{ ul: <ul />, li: <li />}}></Trans>
	  <h4>{t('impress.overview.h4_use')}</h4>
	  <Trans i18nKey="impress.overview.li_use" components={{ ul: <ul />, li: <li />}}></Trans>
	  <h4 id="m13">{t('impress.toc.#4')}</h4>
	  <Trans i18nKey="impress.dsgvo" components={{ul: <ul />, li: <li />, strong: <strong />}}></Trans>
	  <h3 id="m27">{t('impress.toc.#5')}</h3>
	  <Trans i18nKey="impress.recht" components={{p:<p />}}></Trans>
	  <h3 id="m134">{t('impress.toc.#6')}</h3>
	  <Trans i18nKey="impress.cookies" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />, 
	  		MyLink1: (<a href="https://optout.aboutads.info" target="_blank" rel="noopener noreferrer">link</a>),
			MyLink2: (<a href="https://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer">link</a>)}}></Trans>
	  <h3 id="m317">{t('impress.toc.#7')}</h3>
	  <Trans i18nKey="impress.leistungen" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />, 
	  		MyLink1: (<a href="https://optout.aboutads.info" target="_blank" rel="noopener noreferrer">link</a>),
			MyLink2: (<a href="https://www.youronlinechoices.com/" target="_blank" rel="noopener noreferrer">link</a>)}}></Trans>
	  <h3 id="m225">{t('impress.toc.#8')}</h3>
	  <Trans i18nKey="impress.hosting" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />}}></Trans>
	  <h3 id="m182">{t('impress.toc.#9')}</h3>
	  <Trans i18nKey="impress.kontakt" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />}}></Trans>
	  <h3 id="m136">{t('impress.toc.#10')}</h3>
	  <Trans i18nKey="impress.socials" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />, 
	 		link_linkedin: (<a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">link</a>), 
			link_linkedin_priv: (<a href="https://www.linkedin.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">link</a>), 
			link_fb: (<a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">link</a>), 
	 		link_fb_priv: (<a href="https://www.facebook.com/about/privacy" target="_blank" rel="noopener noreferrer">link</a>), 
	 		link_fb_ads: (<a href="https://www.facebook.com/settings?tab=ads" target="_blank" rel="noopener noreferrer">link</a>), 
	 		link_fb_legal: (<a href="https://www.facebook.com/legal/terms/page_controller_addendum" target="_blank" rel="noopener noreferrer">link</a>), 
			link_fb_insight: (<a href="https://www.facebook.com/legal/terms/information_about_page_insights_data" target="_blank" rel="noopener noreferrer">link</a>), 
			link_linkedin_optout: (<a href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out" target="_blank" rel="noopener noreferrer">link</a>)}}></Trans>
	  <h3 id="m12">{t('impress.toc.#11')}</h3>
	  <Trans i18nKey="impress.delete" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />}}></Trans>
	  <h2 id="m15">{t('impress.toc.#12')}</h2>
	  <Trans i18nKey="impress.update" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />}}></Trans>
	  <h3 id="m10">{t('impress.toc.#13')}</h3>
	  <Trans i18nKey="impress.personen" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />}}></Trans>
	  <h3 id="m42">{t('impress.toc.#14')}</h3>
	  <Trans i18nKey="impress.leistungen" components={{p:<p />,ul: <ul />,li: <li />, strong: <strong />, 
	  		MyLink: (<a href="https://datenschutz-generator.de/?l=de" title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken." target="_blank" rel="noopener noreferrer nofollow">link</a>)}}></Trans>
	</main>
  </div>
}

function Impressum() {
  return (
    <Suspense fallback="loading">
	<div className="App">
		<HeaderComponent/>
	</div>
</Suspense>
  );
}

export default Impressum;
